import { render, staticRenderFns } from "./SupplierManufacturingAllergens.vue?vue&type=template&id=18ecec15&scoped=true"
import script from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecec15",
  null
  
)

export default component.exports